import React from 'react';
import Image from './../dom-elements/Image';
import SingleLineCaption from '../dom-elements/SingleLineCaption';
import Stocklist from './Stocklist';
import { returnCategories } from './../../scripts';
import { Link } from 'react-router-dom';

const PublicationsGrid = (props) => {
  const ImageGrid = props.GridItems.map((item, i) =>
    <li className={'publications-grid-li'} key={'publications-grid-' + item.image.id}>
      <div className={'img-grid-item ' + returnCategories(item.nav_categories)}>
        <Link to={'/' + item.link.postType + '/' + item.link.slug} className="grid-item-link">
          <Image source={item.image.small} />
          <SingleLineCaption Headline={item.project_caption.headline} Description={item.project_caption.description} Sep={true}/>
        </Link>
      </div>
    </li>
  );
  return (
    <section id={'filter-grid'}>
      {
        (props.Locations != '/publications/stockists')
        ? <ul className={'publications-grid-wrapper'}>{ImageGrid}</ul>
        : <Stocklist data={props.StocklistData}/>
      }
    </section>
  );
};

export default PublicationsGrid;



// WEBPACK FOOTER //
// ./src/components/filter-pages/PublicationsGrid.js